import { render, staticRenderFns } from "./OfferCardGoals.vue?vue&type=template&id=1e79c614&"
import script from "./OfferCardGoals.vue?vue&type=script&lang=ts&"
export * from "./OfferCardGoals.vue?vue&type=script&lang=ts&"
import style0 from "./OfferCardGoals.vue?vue&type=style&index=0&id=1e79c614&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports